
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "environment": "production",
  "url": "https://lemonsqueezy.com",
  "domain": "lemonsqueezy.com",
  "nuxt": {
    "buildId": "57f4462b-d0c3-46df-b9fa-566f81d00bd7"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
